import fetch from 'cross-fetch'

function handleResponse(response) {
  const contentType = response.headers.get('content-type')
  let isJson = false
  let body = null
  if (contentType && contentType.indexOf('application/json') !== -1) {
    isJson = true
    body = response.json() // there's always a body
  } else {
    body = response.text()
  }
  if (response.status >= 200 && response.status < 300) {
    if (isJson && body) {
      return body.then(output=>({
        'success':true,
        'output': output['output']
      }))
    } else {
      return body.then(text => {
        return {
          'success':true
        }
      })
    }
  } else {
    return body.then(Promise.reject.bind(Promise))
  }
}

export function post(url, data) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(data)
  }).then(handleResponse)
}

export function deleteContent(url) {
  return fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    // body: JSON.stringify(data)
  }).then(handleResponse)
}

export function deleteData(url, data) {
  return fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(data)
  }).then(handleResponse)
}

export function put(url, data) {
  return fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(data)
  }).then(handleResponse)
}

export function get(url) {
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
  })
    .then(handleResponse)
}

export function uploadImage(file) {
  return new Promise((resolve, reject) => {
    const uri = '/api/v2/upload'
    const xhr = new XMLHttpRequest()
    const fd = new FormData()

    xhr.open('POST', uri, true)
    xhr.onload = function() {
      if (xhr.status === 200) {
        resolve(JSON.parse(xhr.response))
      } else {
        reject({
          status: xhr.status,
          statusText: xhr.statusText
        })
      }
    }
    xhr.onerror = function() {
      reject({
        status: xhr.status,
        statusText: xhr.statusText
      })
    }
    fd.append('file', file)
    // Initiate a multipart/form-data upload
    xhr.send(fd)
  })
}

export function getBlob(filename) {
  const url = window.CDN_URL_BLOB === '{{cdn_blob_url}}' ? 'http://127.0.0.1:1929' : window.CDN_URL_BLOB
  return fetch(`${url}/${filename}`, {
    headers: {
      'Content-Type': 'application/json'
    },
  })
    .then((response)=> {
      return response.json().then(output=>output)
    })
}



// WEBPACK FOOTER //
// ./src/util/http.js